module.exports = __webpack_public_path__ + "static/media/where-are-our-readers.0b87e8cf.png";